import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { ProgrammingEventService } from '../../common/services/event.service';

@Component({
  selector: 'prg-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.less'],
  providers: []
})
export class ProgrammingActionsComponent implements OnInit {
  event: Observable<any>;
  automationNav: Observable<any>;

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: ProgrammingEventService,
    private dragulaService: DragulaService
  ) {
    this.event = this.store.select(s => s.advancedProgramming.event.event);

    this.event.subscribe(event => console.log('actionlist.cmp: event update', event));

    dragulaService.drag.subscribe((value) => {
      console.log(`drag: ${value[0]}`);
      this.onDrag(value.slice(1));
    });
    dragulaService.drop.subscribe((value) => {
      console.log(`drop: ${value[0]}`);
      this.onDrop(value.slice(1));
    });
    dragulaService.over.subscribe((value) => {
      console.log(`over: ${value[0]}`);
      this.onOver(value.slice(1));
    });
    dragulaService.out.subscribe((value) => {
      console.log(`out: ${value[0]}`);
      this.onOut(value.slice(1));
    });

  }

  ngOnInit() {
    // this.route.parent.params.take(1).subscribe((params: any) => {
    //   if (params) {
    //     this.eventService.retrieve(params['deviceId'], params['eventId']);
    //   }
    // });

    // this.eventService.refresh();
  }

  retreat() {
    this.router.navigate(['../'], { relativeTo: this.route });
    // this.navigationService.retreat();
  }

  private onDrag(args) {
    let [e, el] = args;
    // do something
  }

  private onDrop(args) {
    let [droppedEl, droppedOnEl, draggedFromEl, droppedBeforeEl] = args;

    var parsed = parseInt(droppedEl.dataset.ciid);
    var movedId = (!isNaN(parsed)) ? parsed : 0;

    parsed = parseInt(droppedOnEl.dataset.ciid);
    var droppedOnId = (!isNaN(parsed)) ? parsed : 0;

    var droppedBeforeId = 0;
    if (droppedBeforeEl) {
      var parsed = parseInt(droppedBeforeEl.dataset.ciid);
      droppedBeforeId = (!isNaN(parsed)) ? parsed : 0;
    }

    let event = undefined;
    this.store.select(s => s.advancedProgramming.event.event).take(1).subscribe(_event => {
      event = _event;
    });
    this.eventService.moveCodeItem(event, movedId, droppedOnId, droppedBeforeId);
  }

  private onOver(args) {
    let [e, el, container] = args;
    if (container.dataset.ciid !== el.dataset.ciid) {
      el.classList.add('drop-target');
    }
  }

  private onOut(args) {
    let [e, el, container] = args;
    // do something
    el.classList.remove('drop-target');
  }

  cutItem(codeitem: any) {
    this.eventService.cutItem(codeitem);
  }

  copyItem(codeitem: any) {
    this.eventService.copyItem(codeitem);
  }

  pasteItem(parent: any) {
    if (!parent) {
      // TODO this could be encapsulated in the service, through a specific API
      this.store.select(state => state.event).take(1).subscribe(
        event => {
          this.eventService.pasteItem(event.event);
        });
    } else {
      this.eventService.pasteItem(parent);
    }
  }

  deleteItem(codeitem: any) {
    this.eventService.deleteCodeItem(codeitem.codeitemId);
  }

  deleteAll() {
    this.eventService.deleteAllCodeItems();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/actions/actions.component.ts